var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.153,
    height: 18.15,
    viewBox: "0 0 18.153 18.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Refresh",
    transform: "translate(-403.9 -210.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-2",
    "data-name": "refresh",
    transform: "translate(427.4 234.706) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-3",
    "data-name": "refresh",
    transform: "translate(5.45 5.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37789",
    "data-name": "Group 37789",
    transform: "translate(0.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37788",
    "data-name": "Group 37788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52897",
    "data-name": "Path 52897",
    d: "M44.56,2.476a.7.7,0,0,0-.762.635L43.7,4.13a8.851,8.851,0,0,0-15.391.738.7.7,0,0,0,1.249.638,7.454,7.454,0,0,1,12.968-.618l-1-.714a.7.7,0,0,0-.815,1.141L43.748,7.48a.7.7,0,0,0,1.106-.507l.34-3.735A.7.7,0,0,0,44.56,2.476Z",
    transform: "translate(-28.237)",
    fill: "#f45e29",
    stroke: "#fff",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37791",
    "data-name": "Group 37791",
    transform: "translate(0.001 10.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37790",
    "data-name": "Group 37790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52898",
    "data-name": "Path 52898",
    d: "M16.578,296.712a.7.7,0,0,0-.943.306,7.454,7.454,0,0,1-12.968.618l1,.714a.7.7,0,0,0,.815-1.141L1.45,295.044a.7.7,0,0,0-1.106.507L0,299.285a.7.7,0,1,0,1.4.127l.093-1.019a8.851,8.851,0,0,0,15.391-.738A.7.7,0,0,0,16.578,296.712Z",
    transform: "translate(-0.001 -294.913)",
    fill: "#f45e29",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.7444f0ca.svg";
export { ForwardRef as ReactComponent };